<template>
    <div id="app">
        <el-container>
            <el-header height="150px">
                <div class="header">
                    <img class="header_logo" src="../../../assets/home/home_purchase/yhyj3_03.png"/>
                </div>
            </el-header>
            <el-main>
                <div class="main dingdanye_dayanshi_qiangzhi_dingti">
                    <div v-if="dz_queren===1" class="main_shxindizhi">
                        <el-row :gutter="1">
                            <el-col :xs="8" :sm="3" :md="3" :lg="3" :xl="3" style="margin-top: 33px">
                                <span class="main_text" style="margin-left: 25px">收货地址:</span>
                            </el-col>
                            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" style="margin-top: 33px">
                                <div v-for="(item,index) in dizhi_list" :key="index" class="main_text"
                                     :style="radio==item.id?'background: #FDEEDE;':''" style="height: 32px;line-height: 32px;">
                                    <el-radio v-model="radio" :label="item.id" fill="#ffffff" style="margin-left: 40px">
                                        <span class="main_text">{{ item.name }}</span>
                                        <span class="main_text shxindizhi_left">{{item.province+item.city+item.area}}&nbsp;{{ item.detail }}</span>
                                    </el-radio>
                                    <span v-if="radio==item.id" class="shxindizhi_left_text2" @click="dizhi_shanchu(item.id)"
                                          style="cursor:pointer;">删除</span>
                                    <span v-if="radio==item.id" class="shxindizhi_left_text" @click="dizhi_moren(item.id)"
                                          style="cursor:pointer;">设为默认收货地址</span>
                                </div>
                                <div class="main_text" style="height: 32px;line-height: 32px;">
                                    <el-radio v-model="radio" label="999" fill="#ffffff" style="margin-left: 40px">
                                        <span class="main_text">使用新地址</span>
                                    </el-radio>
                                </div>
                            </el-col>
                        </el-row>
                        <div v-if="radio==999">
                            <el-row :gutter="1" style="margin-top: 10px">
                                <el-col :offset="4" :xs="8" :sm="3" :md="2" :lg="2" :xl="2" style="margin-top: 3px">
                                    <span class="main_text" style="margin-right: 8px">收</span>
                                    <span class="main_text" style="margin-right: 7px">货</span>
                                    <span class="main_text">人：</span>
                                </el-col>
                                <el-col :xs="8" :sm="3" :md="3" :lg="3" :xl="3">
                                    <div class="main_shouhuo_input">
                                        <el-input size="small " v-model="xinzeng_name" placeholder="请输入内容"></el-input>
                                    </div>
                                </el-col>
                                <el-col :xs="8" :sm="1" :md="1" :lg="1" :xl="1">
                                    <img style="margin-top: 8px;margin-left: 5px" src="../../../assets/home/home_purchase/yhyj_03.png"/>
                                </el-col>
                            </el-row>
                            <el-row :gutter="1" style="margin-top: 10px">
                                <el-col :offset="4" :xs="8" :sm="3" :md="2" :lg="2" :xl="2" style="margin-top: 3px">
                                    <span class="main_text">所在地区：</span>
                                </el-col>
                                <el-col :xs="8" :sm="5" :md="5" :lg="4" :xl="4">
                                    <div class="main_shouhuo_input">
                                        <el-cascader
                                                size="small "
                                                placeholder="试试搜索：青岛"
                                                :options="options"
                                                @change="handleChange"
                                                filterable
                                                v-model="xinzeng_ssq"
                                                popper-class="dingdanchuangjian_xuanzhong_lika_qiangzhi_tihuan">
                                        </el-cascader>
                                    </div>
                                </el-col>

                                <img style="margin-top: 8px;margin-left: 5px"
                                     src="../../../assets/home/home_purchase/yhyj_07.png"/>
                            </el-row>
                            <el-row :gutter="1" style="margin-top: 10px">
                                <el-col :offset="4" :xs="8" :sm="3" :md="2" :lg="2" :xl="2" style="margin-top: 3px">
                                    <span class="main_text">详细地址：</span>
                                </el-col>
                                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                                    <div class="main_shouhuo_input">
                                        <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 2, maxRows: 4}"
                                                placeholder="请输入内容"
                                                v-model="xinzeng_xiangxi">
                                        </el-input>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row :gutter="1" style="margin-top: 10px">
                                <el-col :offset="4" :xs="8" :sm="3" :md="2" :lg="2" :xl="2" style="margin-top: 3px">
                                    <span class="main_text" style="margin-right: 28px">手</span>
                                    <span class="main_text">机：</span>
                                </el-col>
                                <el-col :xs="8" :sm="6" :md="6" :lg="6" :xl="6">
                                    <div class="main_shouhuo_input">
                                        <el-input size="small " v-model="xinzeng_phone" placeholder="请输入内容"></el-input>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="1" style="margin-top: 12px">
                                <el-col :offset="4" :xs="8" :sm="3" :md="2" :lg="2" :xl="2" style="margin-top: 3px">
                                </el-col>
                                <el-col :xs="8" :sm="10" :md="10" :lg="10" :xl="10">
                                <span class="shezhimoren_yangshigenggai" style="margin-right: 3px">
                                    <el-checkbox v-model="checked"></el-checkbox>
                                </span>
                                    <span class="main_text1" style="margin-right: 5px">设置为默认收货地址</span>
                                    <span class="main_text1">设置后系统将在下单时自动选中该收货地址</span>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row :gutter="1" style="margin-top: 23px">
                            <el-col :offset="3" :xs="8" :sm="3" :md="2" :lg="2" :xl="2" style="margin-top: 3px">
                            </el-col>
                            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                                <div class="main_shxindizhi_qurenxinxi">
                                    <div class="main_shxindizhi_qurenxinxi_text" @click="dz_queren_shijian" style="cursor:pointer;">{{radio==999?'添加':'确认收货信息' }}
                                    </div>
                                </div>
                                <div class="main_shxindizhi_qurenxinxi" style="margin-left: 12px;">
                                    <div class="main_shxindizhi_qurenxinxi_text" style="width: 107px;
                      height: 30px;background: #FFFFFF;
                      border: 1px solid #999999;border-radius: 3px;font-size: 14px;
                      font-family: Source Han Sans CN;
                      font-weight: 500;
                      color: #999999;cursor:pointer;
                      line-height: 30px;"
                                         @click="dz_queren=0">取消
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="dz_queren===0" class="main_shxindizhi">
                        <el-row :gutter="1" style="margin-top: 20px">
                            <el-col :xs="8" :sm="3" :md="3" :lg="3" :xl="3" style="margin-top: 21px">
                                <span class="main_text" style="margin-left: 25px">收货地址:</span>
                            </el-col>
                            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" style="margin-top: 21px">
                                <div>
                                    <img src="../../../assets/home/home_purchase/yhyj2_03.png">
                                    <span class="shxindizhi_left_text3">{{ xz_dizhi.name }}</span>
                                    <img src="../../../assets/home/home_purchase/yhyj2_05.png" style="margin-left: 26px">
                                    <span class="shxindizhi_left_text3">{{xz_dizhi.province+xz_dizhi.city+xz_dizhi.area}}&nbsp;{{ xz_dizhi.detail }}</span>
                                    <img src="../../../assets/home/home_purchase/yhyj2_07.png" style="margin-left: 26px">
                                    <span class="shxindizhi_left_text3">{{ xz_dizhi.phone }}</span>
                                </div>
                                <div style="margin-top: 14px;margin-bottom: 17px">
                                <span class="shxindizhi_left_text3" @click="dz_queren=1"  style="margin-left:0px;cursor:pointer">更改</span>
                                    <span class="shxindizhi_left_text3" @click="dz_queren=1,radio='999'" style="margin-left:13px;cursor:pointer;">添加新地址</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="main_dingdan">
                        <div class="main_dingdan_top">
                            <div class="main_dingdan_top_text">
                                店铺:{{list.shop.shop_name}}
                            </div>
                        </div>
                        <el-row v-for="(dd_item,dd_index) in dd_neirong" :key="dd_index" :gutter="1" style="margin-top: 24px">
                            <el-col :xs="8" :sm="3" :md="3" :lg="3" :xl="3">
                                <div class="dingdan_text1">订单{{ dd_index+1 }}：</div>
                            </el-col>
                            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                                <div class="main_dingdan_xinxitop">
                                    <el-row :gutter="10">
                                        <el-col :xs="8" :sm="13" :md="13" :lg="13" :xl="13">
                                            <div class="main_dingdan_xinxitop_tetx" style="margin-left: 11px">货品信息</div>
                                        </el-col>
                                        <el-col :xs="4" :sm="3" :md="3" :lg="3" :xl="3">
                                            <div class="main_dingdan_xinxitop_tetx">数量</div>
                                        </el-col>
                                        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                                            <div class="main_dingdan_xinxitop_tetx1">预估价格(元)</div>
                                        </el-col>
                                        <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4">
                                            <div class="main_dingdan_xinxitop_tetx1">明码标价(元)</div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="main_dingdan_neirong">
                                    <el-row :gutter="10">
                                        <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                                            <img class="main_dingdan_neirong_img" :src="url+'/storage/'+list.cover "/>
                                        </el-col>
                                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                                            <div class="main_dingdan_neirong_text">{{dd_item.specification}}</div>
                                        </el-col>
                                        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" style="margin-top: 20px">
                                            <el-input-number size="mini" v-model="dd_item.sum" @change="shuliang_sj" :min="1" :max="10"
                                                             label="描述文字">
                                            </el-input-number>
                                        </el-col>
                                        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                                            <div class="main_dingdan_neirong_text1">{{ '--' }}</div>
                                        </el-col>
                                        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                                            <div class="main_dingdan_neirong_text1">{{ dd_item.cash }}</div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="main_dingdan_di">
                                    <div class="main_dingdan_di_tishi">
                                        温馨提示：等待卖家确认订单
                                    </div>
                                    <div class="main_dingdan_di_zongjine">
                                        货品总金额:
                                        <span class="main_dingdan_di_zongjine1">
                                            {{ dd_item.cash*dd_item.sum }}
                                        </span>元
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <div class="main_dingdan_fege"></div>
                        <el-row :gutter="1" style="margin-top: 24px">
                            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                                <div class="dingdan_text1" style="margin-top: -1px">订单备注：</div>
                            </el-col>
                            <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
                                <el-input
                                        style="width: 400px"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 4}"
                                        placeholder="请输入内容"
                                        v-model="beizhu">
                                </el-input>
                                <div style="width: 100%;height: 38px"></div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="1" style="margin-top: 24px">
                            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                                <div class="dingdan_text1" style="margin-top: -1px">交易方式：</div>
                            </el-col>
                            <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
                                <div class="main_danbao">
                                    <div class="main_danbao_text">担保交易</div>
                                    <img class="main_danbao_img" src="../../../assets/home/home_purchase/yhyj2_13.png"/>
                                </div>
                                <div style="width: 100%;height: 38px"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="main_heji">
                        <div class="zongji">
                            <span class="main_heji_text1 heji_1">总计:</span>
                            <span class="main_heji_text1 heji_2">货品种类：{{ dd_neirong_zuida+1 }}种</span>
                            <span class="main_heji_text1 heji_3">数量总计：{{dd_zhi}}件</span>
                            <span class="main_heji_text1 heji_5">{{ dd_zongjia }}元</span>
                            <span class="main_heji_text1 heji_4">货品总金额：</span>
                        </div>
                        <div class="heji">
                            <div class="heji_text">
                                应付总额：
                                <span class="heji_text2">{{ dd_zongjia }}</span>元
                            </div>
                        </div>
                    </div>
                    <div class="main_post">
                        <div class="post_right">
                            <div @click="posy" class="post_right_text" style="cursor:pointer;">提交订单</div>
                        </div>
                        <el-dialog
                                title="提示"
                                :visible.sync="fukuan_shijian"
                                width="30%"
                        >
                            <span>是否跳转到用户页</span>
                            <span slot="footer" class="dialog-footer">
                            <el-button @click="fnahui" style="margin-right: 10px">返 回</el-button>
                                <a href="user.html#/trans/purchase">
                                    <el-button type="primary" @click="fukuan_shijian = false">确 定</el-button>
                                </a>
                          </span>
                        </el-dialog>
                        <span class="yingfu_text2">{{ dd_zongjia }}元</span>
                        <span class="yingfu_text1">应付总额：</span>
                    </div>
                </div>

            </el-main>
            <el-footer height="300px">
                <el-row class="footer footer_bottom">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <div class="footer_width">
                            <div class="glzy_top">
                                <a class="xuanzhong wenzi" href="">
                                    <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                                </a>
                                <a class="xuanzhong wenzi" href="">
                                    <span class="footer_text2 footer_lxwm_left">联系我们</span>
                                </a>
                                <a class="xuanzhong wenzi" href="">
                                    <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                                </a>
                                <a class="xuanzhong wenzi" href="">
                                    <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                                </a>
                            </div>
                            <div class="glzy_bottom">
                                <span class="footer_text2 ">Copyright@2020 海粟智链（青岛）科技有限公司版权所有鲁ICP备 19060515号-1</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
    </div>
</template>
<script>
  import {regionDataPlus, CodeToText} from "element-china-area-data"
  import QRCode from 'qrcodejs2'

  export default {
    name: 'index_new',
    data: function () {
      return {
        dialogVisible: false,
        beizhu: '',
        is_open: {
          sousuo: 1,
          lanmu: 1,
        },
        textarea: '',
        options: regionDataPlus,
        diqu: '',
        xiangxi: '',
        list: '',
        shuliang: '',
        jibuqi: '1',
        radio: 1,
        dizhi_list: '',
        dz_queren: 1,
        xz_dizhi: '',
        xinzeng_name: '',
        xinzeng_ssq: '',
        xinzeng_phone: '',
        xinzeng_xiangxi: '',
        checked: false,
        fukuan_shijian: false,
        url: '',
        dd_neirong: '',
        dd_neirong_zuida: '',
        dd_zhi: 0,
        dd_zongjia: 0,
      }
    },
    methods: {
      init() {
        if (localStorage.getItem("uid") == '') {
          window.location = 'user.html#/';
        }
        var t = this;
        t.dd_neirong = t.$store.state.DbSource;
        t.shuliang_sj();
        t.url = window.config.api_url;
        if (t.$route.params.id) {
          t.api_data();
          t.dizhiliebiao();
        }
      },
      shuliang_sj() {
        var t = this;
        t.dd_zhi = 0;
        t.dd_zongjia = 0;
        t.dd_neirong.forEach(function (item, index) {
          t.dd_neirong_zuida = index;
          t.dd_zhi += item.sum;
          t.dd_zongjia += item.cash * item.sum;
        });
      },
      fnahui() {
        this.$router.go(-1);
      },
      qrCode() {
        this.dialogVisible = true;
        var qrcode = '';
        console.log(qrcode);
        this.$nextTick(function () {
          document.getElementById("qrcode").innerHTML = "";
          qrcode = new QRCode("qrcode", {
            width: 150,
            height: 150,
            text: "二维码内容1223",
            colorDark: "#000000",
            colorLight: "#ffffff"
          });
        });
      },
      api_data() {
        this.shuliang = this.$store.state.pathName;
        var t = this;
        var url = window.config.api_url + '/college/goods/' + t.$route.params.id;
        t.axios.get(url).then(res => {
          if (res.data.status) {
            t.$code(res.data.status)
          }
          t.list = res.data
        })
      },
      dizhi_shanchu(e) {
        var t = this;
        var formData = new FormData();
        var id = localStorage.getItem("uid");
        var url = window.config.api_url + '/user/address/remove/' + e;
        formData.append('token', id);
        t.axios.post(url, formData).then(res => {
          console.log(res);
          t.dizhiliebiao()
        });
      },
      dizhi_moren(e) {
        var t = this;
        var formData = new FormData();
        var id = localStorage.getItem("uid");
        var url = window.config.api_url + '/user/address/set/default';
        formData.append('token', id);
        formData.append('address_id', e);
        t.axios.post(url, formData).then(res => {
          console.log(res);
          t.dizhiliebiao()
        });
      },
      dz_queren_shijian() {
        var t = this;
        if (t.radio == 999) {
          return t.xindizhi_post();
        }
        var id = localStorage.getItem("uid");
        var url = window.config.api_url + '/user/address/' + t.radio + '?token=' + id;
        t.axios.get(url).then(res => {
          t.xz_dizhi = res.data
        });
        t.dz_queren = 0
      },
      xindizhi_post() {
        var t = this;
        var formData = new FormData();
        var id = localStorage.getItem("uid");
        var url = window.config.api_url + '/user/address/change';
        formData.append('token', id);
        formData.append('name', t.xinzeng_name);
        formData.append('phone', t.xinzeng_phone);
        formData.append('province', CodeToText[t.xinzeng_ssq[0]]);
        // CodeToText[
        formData.append('province_code', t.xinzeng_ssq[0]);
        formData.append('city', CodeToText[t.xinzeng_ssq[1]]);
        formData.append('city_code', t.xinzeng_ssq[1]);
        formData.append('area', CodeToText[t.xinzeng_ssq[2]]);
        formData.append('area_code', t.xinzeng_ssq[2]);
        formData.append('detail', t.xinzeng_xiangxi);
        formData.append('is_default', t.checked === false ? '0' : 1);
        t.axios.post(url, formData).then(res => {
          if (res.data.status == 0) {
            t.open2(res.data.description)
            this.$router.go(0);
          }
          if (res.data.status == 1) {
            t.open3(res.data.description)
          }
        })
      },
      dizhiliebiao(e) {
        var t = this;
        var id = localStorage.getItem("uid");
        var url = window.config.api_url + '/user/address?token=' + id;
        if (e) {
          url = url + '&page=' + e
        }
        if (t.title) {
          url = url + '&title=' + t.title
        }
        t.axios.get(url).then(res => {
          if (res.data.status) {
            t.$code(res.data.status)
          }
          if (res.data.status == 401) {
            t.opent()
          }
          t.dizhi_list = res.data;
          t.dizhi_list.forEach(function (e) {
            if (e.is_default == 1) {
              t.radio = e.id;
              t.dz_queren_shijian()
            }
          })
        })
      },
      sousuo_xuanxiang(e) {
        this.is_open.sousuo = e
      },
      handleChange() {
      },
      click() {
        // 点击按钮进行一些操作，然后保存数据
        this.$store.commit('saveCurrDbSource', 2);
      },
      posy() {
        var t = this;
        var url = window.config.api_url + '/user/goodsOrder/create';
        var formData = new FormData();
        var id = localStorage.getItem("uid");
        formData.append('token', id);
        formData.append('consignee_phone', t.xz_dizhi.phone);
        formData.append('consignee', t.xz_dizhi.name);
        formData.append('detail_address', t.xz_dizhi.detail);
        formData.append('note', t.beizhu);
        formData.append('province_code', t.xz_dizhi.province_code);//省代码
        formData.append('province', t.xz_dizhi.province);
        formData.append('city_code', t.xz_dizhi.city_code);//市代码
        formData.append('city', t.xz_dizhi.city);
        formData.append('area_code', t.xz_dizhi.area_code);//区代码
        formData.append('area', t.xz_dizhi.area);
        t.dd_neirong.forEach(function (item, index) {
          formData.append('goods[' + index + '][goods_id]', item.goods_id);
          formData.append('goods[' + index + '][number]', item.sum);
          formData.append('goods[' + index + '][spec_id]', item.id);
        });
        t.axios.post(url, formData).then(res => {
          if (res.data.status == 0) {
            t.fukuan_shijian = true
          }
        })
      },
      open3(eve) {//警告
        // var tishi = '最多只能设置三个标签'
        this.$message({
          showClose: true,
          message: eve,
          type: 'warning'
        });
      },
      open2(eve) {//成功
        this.$message({
          showClose: true,
          message: eve,
          type: 'success'
        });
      },

    },
    created() {
      this.init();
    }
  }
</script>
<style lang="less">
    .main_text {
        .el-radio__inner:hover {
            border-color: #EF4F3F !important;
        }

        .el-radio__input.is-checked .el-radio__inner {
            border-color: #EF4F3F !important;
            background: #EF4F3F !important;
        }
    }

    .shezhimoren_yangshigenggai {
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #EF4F3F !important;
            border-color: #EF4F3F !important;
        }

        .el-checkbox__inner:hover {
            border-color: #EF4F3F !important;
        }
    }

    .dingdanye_dayanshi_qiangzhi_dingti {
        .el-textarea__inner:focus {
            outline: 0;
            border-color: #EF4F3F !important;
        }

        .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: #EF4F3F !important;
            outline: 0;
        }

        .el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner {
            border-color: #EF4F3F !important;
        }

        .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
            color: #EF4F3F !important;
            font-weight: 700;
        }
    }

    .dingdanchuangjian_xuanzhong_lika_qiangzhi_tihuan {
        .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
            color: #EF4F3F !important;
            font-weight: 700;
        }
    }
</style>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
    //@head_text : Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";

    .el-footer {
        background-color: #FFFFFF;
        color: #333;
        //text-align: center;
        padding: 0 0;
        //line-height: 60px;
    }

    .el-main {
        background-color: #f4f4f4;
        color: #333;
        //text-align: center;
        padding: 0 0;
        //line-height: 500px;
    }

    .el-header {
        background: #f4f4f4;
        padding: 0 0;
        //border-bottom: #4E6EF2 solid 3px;
    }

    #app {

        width: 100%;

        .header {
            height: 100%;
            width: 80%;
            max-width: 1200px;
            margin-right: auto;
            margin-left: auto;

            .header_logo {
                margin-top: 50px;
            }
        }

        .main {
            height: 100%;
            width: 80%;
            max-width: 1200px;
            margin-right: auto;
            margin-left: auto;

            .main_dizhixuanze {
                width: 100%;
                height: 178px;
                background: #FFFFFF;
                border-radius: 3px;
                margin-top: 20px;
            }

            .main_shxindizhi {
                width: 100%;
                //height: 420px;
                position: relative;
                background: #FFFFFF;
                border-radius: 3px;

                .main_shxindizhi_qurenxinxi {
                    float: left;
                    width: 107px;
                    height: 30px;
                    background: #EF4F3F;
                    border-radius: 3px;
                    margin-bottom: 20px;

                    .main_shxindizhi_qurenxinxi_text {
                        //width: 83px;
                        text-align: center;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 30px;
                    }
                }

                .main_shxindizhi_img {
                    float: left;
                    //line-height: 30px;
                    margin-top: 9px;
                    margin-left: 22px;
                }

                .main_shxindizhi_text {
                    //width: 83px;
                    //height: 12px;
                    font-size: 12px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #C6241D;
                    line-height: 30px;
                }

                .shxindizhi_left {
                    margin-left: 13px;
                }

                .shxindizhi_left_text {
                    float: right;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #555555;
                    line-height: 32px;
                    margin-right: 28px;
                }

                .shxindizhi_left_text2 {
                    float: right;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #555555;
                    line-height: 32px;
                    margin-right: 12px;
                }

                .shxindizhi_left_text3 {
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #666666;
                    margin-left: 4px
                }
            }

            .main_dingdan {
                margin-top: 29px;
                //height: 462px;
                width: 100%;
                background: #FFFFFF;

                .main_dingdan_top {
                    width: 100%;
                    height: 40px;
                    background: #E2EDF8;

                    .main_dingdan_top_text {
                        //width: 142px;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 600;
                        color: #333333;
                        line-height: 40px;
                        margin-left: 12px;
                    }
                }

                .main_dingdan_xinxitop {
                    width: 100%;
                    height: 42px;
                    background: #F9FBFF;
                    border: 1px solid #E2EDF8;

                    .main_dingdan_xinxitop_tetx {
                        //width: 56px;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        line-height: 50px;
                    }

                    .main_dingdan_xinxitop_tetx1 {
                        //width: 56px;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        line-height: 50px;
                        text-align: center;
                    }
                }

                .main_dingdan_neirong {
                    width: 100%;
                    height: 86px;
                    background: #F9FBFF;
                    border: 1px solid #E2EDF8;

                    .el-input-number--mini {
                        width: 100px;
                        margin-left: 30px;
                    }

                    .main_dingdan_neirong_img {
                        //width: 60px;
                        margin-left: 13px;
                        margin-right: 18px;
                        height: 60px;
                    }

                    .main_dingdan_neirong_text {
                        //width: 215px;
                        //height: 32px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        //line-height: 18px;
                    }

                    .main_dingdan_neirong_text1 {
                        //width: 61px;
                        text-align: center;
                        //height: 13px;
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        line-height: 65px;
                    }
                }

                .main_dingdan_di {
                    //width: 1028px;
                    width: 100%;
                    height: 80px;
                    background: #F9FBFF;
                    border: 1px solid #E2EDF8;

                    .main_dingdan_di_tishi {
                        //width: 182px;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        margin-left: 10px;
                        margin-top: 10px;
                        float: left;
                        //line-height: 100px;
                    }

                    .main_dingdan_di_zongjine {
                        margin-right: 15px;
                        margin-top: 10px;
                        float: right;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        //line-height: 100px;
                        .main_dingdan_di_zongjine1 {
                            //width: 66px;
                            //height: 14px;
                            font-size: 18px;
                            font-family: Source Han Sans CN;
                            font-weight: 500;
                            color: #FF6000;
                            //line-height: 100px;
                        }
                    }
                }

                .main_dingdan_fege {
                    //width: 1144px;
                    height: 1px;
                    background: #E1E1E1;
                    width: 92%;
                    margin-left: 4%;
                    margin-top: 25px;
                }

                .dingdan_text1 {
                    //width: 40px;
                    //height: 14px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #999999;
                    //line-height: 100px;
                    margin-top: 10px;
                    margin-left: 25px;
                }

                .main_danbao {
                    position: relative;
                    width: 120px;
                    height: 36px;
                    background: #FFFFFF;
                    border: 1px solid #EF4F3F;

                    .main_danbao_text {
                        //width: 55px;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        line-height: 36px;
                        text-align: center;
                    }

                    .main_danbao_img {
                        position: absolute;
                        margin-top: -21px;
                        margin-left: 91px;
                    }
                }
            }

            .main_heji {
                margin-top: 11px;
                width: 100%;
                height: 134px;
                background: #FEF8E1;
                border: 1px solid #FBE1A3;

                .zongji {
                    margin-top: 20px;

                    .main_heji_text1 {
                        //width: 31px;
                        //height: 14px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        //line-height: 100px;
                    }

                    .heji_1 {
                        margin-left: 25px;
                    }

                    .heji_2 {
                        margin-left: 70px;
                    }

                    .heji_3 {
                        margin-left: 10px;
                    }

                    .heji_4 {
                        float: right;
                    }

                    .heji_5 {
                        float: right;
                        margin-right: 55px;
                    }
                }

                .heji {
                    margin-top: 40px;

                    .heji_text {
                        float: right;
                        margin-right: 35px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #333333;
                        //line-height: 100px;
                        .heji_text2 {
                            //width: 85px;
                            //height: 18px;
                            font-size: 22px;
                            font-family: Source Han Sans CN;
                            font-weight: bold;
                            color: #EF4F3F;
                            //line-height: 100px;
                        }
                    }
                }
            }

            .main_post {
                width: 100%;
                height: 60px;
                background: #FFFFFF;
                margin-bottom: 100px;
                margin-top: 20px;

                .post_right {
                    width: 189px;
                    height: 60px;
                    background: #EF4F3F;
                    float: right;

                    .post_right_text {
                        //width: 71px;
                        //height: 17px;
                        text-align: center;
                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: 600;
                        color: #FFFFFF;
                        line-height: 60px;
                    }
                }

                .yingfu_text1 {
                    float: right;
                    //width: 60px;
                    //height: 14px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333333;
                    line-height: 60px;
                }

                .yingfu_text2 {
                    float: right;
                    //width: 85px;
                    //height: 18px;
                    font-size: 22px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #EF4F3F;
                    line-height: 60px;
                    margin-right: 20px;
                }
            }
        }

        .footer {
            width: 100%;
            height: 255px;
            background: #FFFFFF;
            border-bottom: #E1E1E1 solid 1px;

            .footer_width {
                width: 80%;
                max-width: 1200px;
                margin-right: auto;
                margin-left: auto;

                .xdsk_top {
                    position: relative;
                    margin-top: 70px;

                    .footer_img_xinshou {
                        //margin-left: 5px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_img_duiwai {
                        //margin-left: 155px;
                        //margin-top: 13px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_img_shiming {
                        //margin-left: 155px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_img_kefu {
                        //margin-left: 155px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_xinshou_left {
                        margin-left: 60px;
                    }

                    .footer_dsk_left {
                        margin-left: 60px;
                    }
                }

                .xdsk_bottom {
                    margin-top: 38px;

                    .footer_kongjian_left {
                        margin-left: 17px;
                    }

                    .footer_jiaoyi_left {
                        margin-left: 184px;
                    }

                    .footer_shiming_left {
                    }

                    .footer_tousu_left {
                        margin-left: 520px;
                    }

                    .footer_changjian_left {
                        margin-left: 945px;
                    }
                }

                .glzy_top {
                    margin-top: 51px;

                    .footer_gyyyj_left {
                        padding-right: 20px;
                        border-right: #E1E1E1 solid 1px;
                    }

                    .footer_lxwm_left {
                        margin-left: 29px;
                        padding-right: 21px;
                        border-right: #E1E1E1 solid 1px;
                    }
                }

                .glzy_bottom {
                    margin-top: 45px;
                }
            }
        }

        .footer_bottom {
            border-bottom: none;
            height: 223px;
        }
    }

    .youfudong {
        float: right;
    }

    .main_text {
        //width: 69px;
        //height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #666666;
        //line-height: 100px;
    }

    .main_text1 {
        //width: 108px;
        //height: 12px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        //line-height: 100px;
    }

    .head_text {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #333333;
        line-height: 38px;
    }

    .footer_text1 {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 150;
        color: #666666;
        //line-height: 30px;
    }

    .footer_text2 {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        //line-height: 30px;
    }

    .footer_text3 {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #333333;
        //line-height: 30px;
    }

    .xuanzhong:hover {
        //color:#4E6EF2;
        text-decoration: none;
    }

    .wenzi {
        text-decoration: none;
    }
</style>